﻿import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { getPreferredStartRoute, setSession } from '../../auth/session';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: 'admin@ajfinanceiro.local',
    senha: 'Admin@123456',
    tenant_slug: 'default',
  });

  const canSubmit = useMemo(() => {
    return form.email && form.senha && form.tenant_slug;
  }, [form]);

  const onChange = (field, value) => {
    setForm((old) => ({ ...old, [field]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit || loading) return;

    try {
      setLoading(true);
      const { data } = await axios.post('/api/auth/login', form);

      const empresas = Array.isArray(data.empresas) ? data.empresas : [];
      const empresaDefault = empresas.find((empresa) => getPreferredStartRoute(empresa) !== '/login') || empresas[0];
      if (!empresaDefault?.empresa_id) {
        toast.error('Usuario sem empresa vinculada');
        return;
      }

      setSession({
        token: data.token,
        tenantId: data.tenant.id,
        tenantSlug: data.tenant.slug,
        user: data.user,
        empresas,
        empresaId: empresaDefault.empresa_id,
      });

      toast.success('Login realizado com sucesso');
      navigate(getPreferredStartRoute(empresaDefault), { replace: true });
    } catch (error) {
      toast.error(error.response?.data?.error || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">FinancePro SaaS</h1>
          <p className="text-sm text-gray-600 mt-1">Acesse sua conta</p>
        </div>

        <form className="p-6 space-y-4" onSubmit={onSubmit}>
          <div>
            <label className="form-label">Tenant</label>
            <input
              className="form-input"
              value={form.tenant_slug}
              onChange={(e) => onChange('tenant_slug', e.target.value)}
              placeholder="default"
            />
          </div>

          <div>
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-input"
              value={form.email}
              onChange={(e) => onChange('email', e.target.value)}
              placeholder="admin@empresa.com"
            />
          </div>

          <div>
            <label className="form-label">Senha</label>
            <input
              type="password"
              className="form-input"
              value={form.senha}
              onChange={(e) => onChange('senha', e.target.value)}
              placeholder="********"
            />
          </div>

          <button type="submit" className="btn-primary w-full" disabled={!canSubmit || loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
